import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import ru from "./ru.json";
import ar from "./ar.json";
import zh from "./zh.json";

export const LANGS = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "ru", label: "Русский", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "zh", label: "中文", dir: "ltr" },
];

function applyDir(code) {
  const meta = LANGS.find((l) => l.code === code) || LANGS[0];
  document.documentElement.dir = meta.dir;
  document.documentElement.lang = meta.code;
}

export function setLanguage(code) {
  const lang = LANGS.some((l) => l.code === code) ? code : "en";
  i18n.changeLanguage(lang);
  applyDir(lang);
  try {
    localStorage.setItem("pruva-lang", lang);
  } catch (e) {
    console.warn("localStorage unavailable", e);
  }
}

let initial = "en";
try {
  initial = localStorage.getItem("pruva-lang") || "en";
} catch (e) {
  console.warn("localStorage unavailable", e);
}
if (!LANGS.some((l) => l.code === initial)) initial = "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
    ar: { translation: ar },
    zh: { translation: zh },
  },
  lng: initial,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

applyDir(initial);

export default i18n;
